package horcrux.frontend.common.views.components.input.selectors

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.HasViewName
import horcrux.frontend.common.MaybeState
import mui.icons.material.Edit
import mui.material.IconButton
import mui.material.IconButtonColor
import mui.material.IconButtonEdge
import mui.material.MenuItem
import mui.material.Size
import mui.material.SvgIconProps
import mui.material.SvgIconSize
import mui.system.sx
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import react.dom.events.MouseEvent
import web.cssom.number
import web.dom.Element
import web.svg.SVGSVGElement

interface MenuOptionEnum : HasViewName {
    override val viewName: String
    val alwaysVisible: Boolean
}

interface MenuOptionEnumCompanion<Option : MenuOptionEnum> {
    val menuOptions: List<Option>
    val menuView: FC<MenuSelectorProps<Option>>
}

external interface MenuSelectorProps<Option : MenuOptionEnum> : Props {
    var globalAppState: GlobalAppState
    var isVisibleMaybe: ((Option) -> Boolean)?
    var onClick: (Option) -> Unit
    var svgIconPropsMaybe: SvgIconProps?
}

fun <Option : MenuOptionEnum, Companion : MenuOptionEnumCompanion<Option>> MenuOptionEnumCompanion<Option>.menuSelector(
    id: String,
): FC<MenuSelectorProps<Option>> = FC { props ->
    val anchorElementMaybeState = MaybeState<Element?>()
    val openMenu = { event: MouseEvent<SVGSVGElement, *> ->
        anchorElementMaybeState.set(event.currentTarget)
    }
    val closeMenu = { anchorElementMaybeState.reset() }
    IconButton {
        this.size = Size.large
        this.edge = IconButtonEdge.end
        this.color = IconButtonColor.inherit
        this.id = id
        this.ariaLabel = "${id}-menu"
        Edit {
            props.svgIconPropsMaybe?.let { svgIconProps ->
                +svgIconProps
            } ?: run {
                this.fontSize = SvgIconSize.large
            }
            this.onClick = { openMenu(it) }
        }

        mui.material.Menu {
            this.anchorEl = anchorElementMaybeState.get()?.let { { _ -> it } }
            this.open = !anchorElementMaybeState.isReset()
            this.onClose = { closeMenu() }
            this@menuSelector.menuOptions.forEach { menuOption ->
                val isVisible = props.isVisibleMaybe?.let { it(menuOption) } ?: true
                MenuItem {
                    +menuOption.viewName
                    this.onClick = {
                        props.onClick(menuOption)
                        closeMenu()
                    }
                    this.sx {
                        this.opacity =
                            if (menuOption.alwaysVisible || isVisible) number(
                                1.0
                            ) else number(
                                0.1
                            )
                    }
                }
            }
        }
    }
}
